module.exports = __webpack_public_path__ + "static/media/House.18e8366d.svg";